<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main>
      <div class="content" content>
        <app-feature-list-container>
          <app-feature-list-item [label]="'feature.properties.property.unit'">
          </app-feature-list-item>

          <app-feature-list-item
            *ngFor="let feature of features; let i = index"
            [label]="i + 1 + '. ' + feature.properties.value.unit"
            value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
          >
          </app-feature-list-item>
        </app-feature-list-container>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
